module.exports = __webpack_public_path__ + "static/media/S (133).4388c112.jpg";